import { JsonTimesheetModel, TimesheetModel } from '../models/low-level/timesheet.model';
import { NOTIFICATION_STATUS_CODE } from '../enums/notification-status-code.enum';
import { NotificationCompletedListModel } from '../models/low-level/notification-completed.model';

export class LogUtilities {
    public static getLogOutputCompletedNotifications(
        completedNotifications: NotificationCompletedListModel,
    ): CompletedNotificationLog[] {
        return Object.values(completedNotifications.completedNotifications).map((notif) => ({
            id: notif.id.toString(),
            status: notif.status,
        }));
    }

    public static getLogOutputTimesheetModel(timesheet: TimesheetModel): Partial<JsonTimesheetModel> {
        return {
            startOfWork: timesheet.startOfWork.toISOString(),
            notifications: timesheet.notifications.map((notif) => JSON.parse(JSON.stringify(notif))),
            manualTimesheetEntries: timesheet.manualTimesheetEntries.map((manual) =>
                JSON.parse(JSON.stringify(manual)),
            ),
            endOfWork: timesheet.endOfWork.toISOString(),
            isSubmitted: timesheet.isSubmitted,
        };
    }
}

type CompletedNotificationLog = {
    id: string;
    status: NOTIFICATION_STATUS_CODE;
};
